export enum ReceiptForwardMode {
  FULL = 'full',
  REDACTED = 'redacted',
}
